// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nJ0Mq","inner":"Footer_inner__3IUdP","nextIcon":"Footer_nextIcon__1kWzR","innerLeft":"Footer_innerLeft__2dPYw"};